import type {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'
import type {PerfilLineaRead} from '@/hooks/empresa/perfil_cargo/use-perfiles-cargo'

/** Compartida por las tres tarjetas para que los `data-testid` que lee el E2E sean los mismos. */
export function Propuestas({
  bloque,
  propuestas,
  editable,
  pending,
  onAdoptarTodas,
  titulo,
  children,
}: {
  bloque: string
  propuestas: PerfilLineaRead[]
  editable: boolean
  pending: boolean
  onAdoptarTodas: (lineas: PerfilLineaRead[]) => void
  titulo?: string
  children: ReactNode
}) {
  const {t} = useTranslation()
  return (
    <>
      <h4 className="mt-4 text-xs uppercase tracking-wide text-muted-foreground">
        {titulo ?? t('perfilCargo.detalle.propuestasTitulo')}
      </h4>
      {propuestas.length === 0 ? (
        <p className="mt-1 text-sm text-muted-foreground" data-testid={`sin-propuestas-${bloque}`}>
          {t('perfilCargo.detalle.sinPropuestas')}
        </p>
      ) : (
        <>
          {editable && propuestas.length > 1 && (
            <Button
              className="mt-2"
              size="sm"
              variant="outline"
              disabled={pending}
              data-testid={`adoptar-todas-${bloque}`}
              onClick={() => onAdoptarTodas(propuestas)}>
              {t('perfilCargo.detalle.adoptarTodas', {count: propuestas.length})}
            </Button>
          )}
          {children}
        </>
      )}
    </>
  )
}
